const singleFormSection = $('.single-form-section-parent');

const addSingleFormInAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };
  const formPlacer = singleFormSection.find('.single-form-section-content').eq(0);
  const singleFormInTL = gsap.timeline({ paused: true });

  if (isDesktop()) {
    singleFormInTL.add(
      animateSectionTopperIn({
        sectionParent: singleFormSection,
        gradientConfig: gradientConfig,
      }).play(),
      0
    );
  }
  singleFormInTL.add(animateFormIn(formPlacer).play(), 0.633);
  singleFormInTL.add(() => animateFormLines(singleFormSection, 0), 0.633);

  return singleFormInTL;
};

const initSingleForm = () => {
  const singleFormInTL = addSingleFormInAnimation();
  ScrollTrigger.create({
    trigger: singleFormSection,
    start: 'top top+=90%',
    end: 'bottom bottom',
    once: true,
    onEnter: () => {
      singleFormInTL.play();
    },
  });
}

/*
$(window).on('load', function () {
  initSingleForm();
});
*/

addSectionObserver(singleFormSection, initSingleForm);
